import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useApi } from "./api";

/* Who is signed in. Mirrors header.php: the Flask session (checked against the sessions table) decides. */
const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const api = useApi();
  const [user, setUser] = useState(undefined); // undefined = still checking, null = signed out
  const [notice, setNotice] = useState(null);

  const refresh = useCallback(async () => {
    try { const me = await api.get("/api/auth/me"); setUser({ id: me.id, name: me.username, role: me.role, home: me.redirect }); }
    catch { setUser(null); }
  }, [api]);
  useEffect(() => { refresh(); }, [refresh]);
  useEffect(() => {
    const out = () => { setUser((u) => { if (u) setNotice("Your session has ended. Please sign in again."); return null; }); };
    window.addEventListener("ae2c:signed-out", out);
    return () => window.removeEventListener("ae2c:signed-out", out);
  }, []);

  const login = async (username, password) => {
    const r = await api.post("/api/auth/login", { username, password });
    setNotice(null);
    setUser({ id: r.user.id, name: r.user.username, role: r.user.role, home: r.redirect });
    return r.redirect;
  };
  const logout = async () => {
    try { await api.post("/api/auth/logout", {}); } catch { /* signed out either way */ }
    setNotice(null);
    setUser(null);
  };
  return <AuthContext.Provider value={{ user, login, logout, notice, setNotice }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
